import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import Cookies from 'js-cookie'
import moment from 'moment'
import { Card } from 'react-bootstrap'
import Swal from 'sweetalert2'
import config from '../../../config'
import Colors from '../../../constants/Colors'

const BannedUser = ({ user, setUserModalVisible, onClose }) => {
  const { id, banExpiredAt } = user

  const dispatch = useDispatch()

  const [suspend, setSuspend] = useState({ reason: '', expiredAt: '' })

  const handleClickBannedForLife = () => {
    const dateTime = new Date()
    dateTime.setFullYear(9999)
    const date = dateTime.toISOString().split('T')[0]
    setSuspend({ ...suspend, expiredAt: date })
  }

  const handleSuspend = async () => {
    Swal.fire({
      title: 'ต้องการแบนสมาชิกใช่หรือไม่?',
      icon: 'question',
      showCancelButton: false,
      confirmButtonColor: Colors.SOFT_BLUE,
      confirmButtonText: 'ยืนยัน',
    }).then((event) => {
      if (event.isConfirmed) {
        onSuspend(suspend.reason, 'แบนสมาชิก', moment(suspend.expiredAt).toISOString())
      }
    })
  }

  const handleUnSuspend = async () => {
    Swal.fire({
      title: 'ต้องการยกเลิกการแบนสมาชิกใช่หรือไม่?',
      icon: 'question',
      showCancelButton: false,
      confirmButtonColor: Colors.SOFT_BLUE,
      confirmButtonText: 'ยืนยัน',
    }).then((event) => {
      if (event.isConfirmed) {
        onSuspend('ยกเลิกการแบน', 'ยกเลิกการแบนสมาชิก', null)
      }
    })
  }

  const onSuspend = async (reason, actionMessage, expiredAt) => {
    try {
      dispatch({ type: 'loading_show' })
      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/users/suspend`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
        body: JSON.stringify({ id, reason, expiredAt }),
      })
      const {
        status: { code, description },
      } = await response.json()

      if (code !== 0) {
        throw new Error(description)
      }

      Swal.fire({
        title: `${actionMessage} สำเร็จ!`,
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: Colors.SOFT_BLUE,
        confirmButtonText: 'ปิด',
      }).then(() => {
        setUserModalVisible(false)
        onClose()
      })
    } catch (error) {
      console.error('Error while trying to suspend user.', error)

      Swal.fire({
        title: `${actionMessage} ไม่สำเร็จ! \n${error}`,
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: Colors.LIGHT_RED,
        confirmButtonText: 'ปิด',
      })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  return (
    <Card body style={{ height: 'auto' }}>
      <span>กรอกเหตุผล</span>
      <textarea
        placeholder="เช่น อายุต่ำกว่า 20 ปี, การโกง, การละเมิด ข้อตกลงการใช้งาน ฯลฯ"
        rows={3}
        className="form-control mb-4 text-black"
        value={suspend.reason}
        onChange={(e) => setSuspend({ ...suspend, reason: e.target.value })}
      />
      <span>เลือกเวลาสำหรับยกเลิกการ แบน/บล็อก</span>
      <input
        type="date"
        className={`form-control ${suspend.expiredAt === '' ? 'text-dark' : 'text-black'}`}
        value={suspend.expiredAt}
        onChange={(e) => {
          setSuspend({ ...suspend, expiredAt: e.target.value })
        }}
      />
      <button className="mt-2 mb-4 btn btn-outline-danger" onClick={handleClickBannedForLife}>
        แบนสมาชิกถาวร
      </button>
      <div className="d-flex">
        <button
          className="btn btn-danger btn-block mr-1"
          disabled={suspend.reason === '' || suspend.expiredAt === ''}
          onClick={handleSuspend}
        >
          ยืนยันการแบน
        </button>
        {banExpiredAt && moment(banExpiredAt).isAfter(moment()) && (
          <button className="btn btn-primary btn-block mt-0 ml-1" onClick={handleUnSuspend}>
            ยกเลิกการแบน
          </button>
        )}
      </div>
    </Card>
  )
}

export default BannedUser
